/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ApiCredentials = core.serialization.object({
    clientId: core.serialization.string(),
    secret: core.serialization.string(),
});
